import script from "./ManageWebhooksModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageWebhooksModal.vue?vue&type=script&setup=true&lang=js"

import "./ManageWebhooksModal.vue?vue&type=style&index=0&id=0b70632c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b70632c"]])

export default __exports__